import { IConfigurationModel } from "@nf/common";

import LandingPageCard from "components/LandingPage/LandingPageCard";
import LandingPageHeroSection from "components/LandingPage/LandingPageHeroSection";
import LandingPageBrand from "components/LandingPage/LandingPageBrand";
import AppFooterDesktop from "components/AppFooter/AppFooterDesktop";

import styles from "./NotAvailableScreen.module.scss";

export type NotAvailableComponent = {
  backgroundImageUrl?: string;
  title?: string;
  availability: {
    message?: string;
    label?: string;
    countries?: Array<{
      name?: string;
      redirectUrl?: string;
    }>;
  };
};

export interface NotAvailableScreenProps {
  component: NotAvailableComponent;
  configuration?: IConfigurationModel;
}

const NotAvailableScreen = ({
  component,
  configuration,
}: NotAvailableScreenProps) => {
  const availability = component.availability;
  const countries = availability?.countries;

  return (
    <div className={styles.container}>
      <LandingPageHeroSection image={component.backgroundImageUrl}>
        <LandingPageBrand>{component.title}</LandingPageBrand>

        <LandingPageCard>
          <h1 className={styles.message}>{availability.message}</h1>

          <h2 className={styles.label}>{availability.label}</h2>

          <div className={styles.countries}>
            {countries?.map((country) => (
              <a
                key={country.redirectUrl}
                href={country.redirectUrl}
                className={styles.country}
              >
                {country.name}
              </a>
            ))}
          </div>
        </LandingPageCard>
      </LandingPageHeroSection>

      <div className={styles.footer}>
        <AppFooterDesktop configuration={configuration} />
      </div>
    </div>
  );
};

export default NotAvailableScreen;
